/* tslint:disable */
/* eslint-disable */

/** GET /CourierReviews/public-summary — aggregate over approved reviews. */
export interface CourierReviewSummary {
    count: number;
    averageRating: number;
}

export function CourierReviewSummaryFromJSON(json: any): CourierReviewSummary {
    if ((json === undefined) || (json === null)) {
        return { count: 0, averageRating: 0 };
    }
    return {
        'count': Number(json['count'] ?? 0),
        'averageRating': Number(json['averageRating'] ?? 0),
    };
}
